import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Badge } from "../ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Sparkles, ChevronRight, Check, AlertTriangle, Clock, RefreshCw } from "lucide-react";
import { cn } from "../../lib/utils";

const GIORNI_SHORT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

const COLORI_REPARTO = {
  'cucina': { dot: 'bg-orange-500' },
  'sala': { dot: 'bg-blue-500' },
  'laboratorio': { dot: 'bg-purple-500' },
  'altro': { dot: 'bg-gray-500' }
};

export const GeneraTurniDialog = ({ open, onOpenChange, anteprimaGenerazione, salvando, onSalva }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-violet-500" />Anteprima Turni Generati</DialogTitle>
      </DialogHeader>
      {anteprimaGenerazione && (
        <div className="space-y-4">
          {anteprimaGenerazione.messaggi?.map((msg, i) => (<p key={i} className="text-sm text-muted-foreground">{msg}</p>))}

          {anteprimaGenerazione.riepilogo_ore?.length > 0 && (
            <div className="bg-gradient-to-r from-violet-50 to-indigo-50 dark:from-violet-950/30 dark:to-indigo-950/30 rounded-xl p-4">
              <Label className="text-sm font-bold text-violet-700 dark:text-violet-300 flex items-center gap-2"><Clock className="h-4 w-4" />Riepilogo Ore Settimanali</Label>
              <div className="mt-3 space-y-2">
                {anteprimaGenerazione.riepilogo_ore.map((r, i) => {
                  const colore = COLORI_REPARTO[r.reparto] || COLORI_REPARTO['altro'];
                  return (
                    <div key={i} className="bg-white/60 dark:bg-black/20 rounded-lg px-3 py-2">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2"><div className={cn("w-2 h-2 rounded-full", colore.dot)} /><span className="font-medium text-sm">{r.utente_nome}</span></div>
                        <div className="flex items-center gap-3 text-sm">
                          <span className="text-muted-foreground">{r.turni} turni</span>
                          <Badge variant="secondary" className="bg-violet-100 text-violet-700 dark:bg-violet-900 dark:text-violet-300 font-bold">{r.ore}h</Badge>
                        </div>
                      </div>
                      <div className="flex flex-wrap items-center gap-1 mt-1">
                        {r.giorni_riposo?.length > 0 && (<span className="text-[10px] px-1.5 py-0.5 bg-gray-100 text-gray-600 rounded-full">Riposo: {r.giorni_riposo.map(g => GIORNI_SHORT[g]).join(", ")}</span>)}
                        {r.assenze?.length > 0 && r.assenze.map((a, ai) => (
                          <span key={ai} className={cn("text-[10px] px-1.5 py-0.5 rounded-full", a.tipo === "malattia" ? "bg-red-100 text-red-600" : a.tipo === "permesso" ? "bg-amber-100 text-amber-600" : "bg-blue-100 text-blue-600")}>
                            {a.tipo === "malattia" ? "Malattia" : a.tipo === "permesso" ? "Permesso" : "Ferie"} {GIORNI_SHORT[a.giorno_idx]}
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {anteprimaGenerazione.conflitti?.length > 0 && (
            <div>
              <Label className="text-sm font-medium text-amber-600">Attenzione:</Label>
              <div className="mt-2 space-y-1">
                {anteprimaGenerazione.conflitti.map((c, i) => (
                  <div key={i} className="text-xs bg-amber-50 dark:bg-amber-950/30 p-2 rounded flex items-start gap-2">
                    <AlertTriangle className="h-3 w-3 text-amber-500 mt-0.5" /><span>{c.messaggio}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          <details className="group">
            <summary className="cursor-pointer text-sm font-medium text-muted-foreground hover:text-foreground flex items-center gap-2">
              <ChevronRight className="h-4 w-4 transition-transform group-open:rotate-90" />
              Dettaglio turni ({anteprimaGenerazione.turni_generati?.length})
            </summary>
            <div className="mt-2 max-h-40 overflow-y-auto space-y-1 pl-6">
              {anteprimaGenerazione.turni_generati?.map((t, i) => (
                <div key={i} className="text-xs bg-muted/50 p-2 rounded flex justify-between">
                  <span>{GIORNI_SHORT[t.giorno_idx]} - {t.fascia_nome}</span>
                  <span className="font-medium">{t.utente_nome}</span>
                </div>
              ))}
            </div>
          </details>
        </div>
      )}
      <DialogFooter className="gap-2 sm:gap-0">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
        <Button onClick={onSalva} disabled={salvando || !anteprimaGenerazione?.turni_generati?.length} className="bg-gradient-to-r from-violet-600 to-indigo-600">
          {salvando ? <RefreshCw className="h-4 w-4 animate-spin mr-2" /> : <Check className="h-4 w-4 mr-2" />}
          Conferma e Salva
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
